<template functional>
  <v-card width="100%">
    <v-card-title class="pb-1">{{ props.heading }}</v-card-title>
    <v-card-text class="primary--text text--lighten-1 display-2 font-weight-medium">{{ props.title }}</v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    heading: {
      type: String,
      required: true
    },
    title: {
      type: Number,
      required: true
    }
  }
}
</script>
